import { answerRichTextOptions } from '@entries/contentful-faq-page-template'
import { withDisplayName } from '@hocs/with-display-name'
import RichText from '@resolvers/rich-text'
import { Accordion } from '@ui/accordion'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulFaqPageAccordion: Utils.EntryFC<
  Queries.ContentfulFaqPageAccordionFragment
> = ({ content: { id, title, answer } }) => (
  <Accordion id={id} title={title}>
    <RichText content={answer} options={answerRichTextOptions} />
  </Accordion>
)

export const query = graphql`
  fragment ContentfulFaqPageAccordion on ContentfulFaqPage {
    ...ContentfulEntry
    title
    answer {
      ...ContentfulFaqPageAnswer
    }
  }
`

export default withDisplayName(
  ContentfulFaqPageAccordion,
  'ContentfulFaqPageAccordion'
)
